import React from "react";
import { Container } from "reactstrap";
import { Helmet } from "react-helmet";
import Layout from "../../components/layout";
import AdeudosComponent from "../../components/adeudos";

interface Props {}
interface State {}

export default class AdeudosPage extends React.Component<Props, State> {
  render() {
    return (
      <main>
        <Helmet title="Expediente Documentos" />
        <Layout>
          <Container>
            <AdeudosComponent />
          </Container>
        </Layout>
      </main>
    );
  }
}
